export const WebSocketMessageType = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  HEARTBEAT: 'heartbeat',
  ERROR: 'error',
  OUTGOING: 'outgoing',
  WORKFLOW_RUN_COMPLETED: 'workflow_run_completed',
} as const;
export type WebSocketMessageType =
  (typeof WebSocketMessageType)[keyof typeof WebSocketMessageType];
